import { makeApiRequestPromise } from "../../lib/api";
import { toast } from "react-toastify";

export const listApiKeys = async (): Promise<string[]> => {
  try {
    const response = await makeApiRequestPromise({
      path: "/api/keys/list",
      method: "GET",
    });

    const apiKeys = response.map((item: { api_key: string }) => item.api_key);
    return apiKeys;
  } catch (error) {
    console.error("Error fetching API keys list:", error);
    toast.error("Failed to retrieve API keys");
    return [];
  }
};

export const createApiKey = async (): Promise<string> => {
  const newApiKey = await makeApiRequestPromise({
    path: "/api/keys/create",
    method: "POST",
    baseUrl: import.meta.env.VITE_EVAL_API_URL as string,
  });
  return newApiKey;
};

export const deleteApiKey = async (apiKey: string): Promise<void> => {
  await makeApiRequestPromise({
    path: "/api/keys/delete",
    method: "DELETE",
    baseUrl: import.meta.env.VITE_EVAL_API_URL as string,
    body: { api_key: apiKey },
  });
};

export const copyToClipboard = async (text: string): Promise<void> => {
  await navigator.clipboard.writeText(text);
};

